import { action, computed, observable } from 'mobx';
import { SubscriptionPlan } from '../models';
import {
  default as getRepository,
  SubscriptionPlanRepository
} from '../repositories/SubscriptionPlan';
import AsyncOperation from './AsyncOperation';

type SubscriptionPlansOperation = AsyncOperation<
  SubscriptionPlan[] | undefined
>;

export class SubscriptionPlanStore {
  public repository: SubscriptionPlanRepository = getRepository();

  @observable
  public subscriptionPlans: SubscriptionPlansOperation = AsyncOperation.resolved as SubscriptionPlansOperation;

  @computed
  public get subscriptionPlan(): AsyncOperation<SubscriptionPlan> {
    const { subscriptionPlans } = this;

    return new AsyncOperation(
      (async () => {
        const plans = await subscriptionPlans.originalPromise;

        if (!plans || !plans.length) {
          throw new Error(`No plans returned from API`);
        }

        return plans[0];
      })()
    );
  }

  @action
  public fetchSubscriptionPlans = async (
    force: boolean = false
  ): Promise<SubscriptionPlan[] | undefined> => {
    if (
      force ||
      !this.subscriptionPlans ||
      this.subscriptionPlans === AsyncOperation.resolved
    ) {
      this.subscriptionPlans = new AsyncOperation<
        SubscriptionPlan[] | undefined
      >(this._fetchSubscriptionPlans());
    }

    return this.subscriptionPlans.promise;
  };

  private _fetchSubscriptionPlans = async (): Promise<SubscriptionPlan[]> => {
    return this.repository.fetchAll();
  };
}

export default SubscriptionPlanStore;



// WEBPACK FOOTER //
// ./src/app/stores/SubscriptionPlanStore.ts